import { render, staticRenderFns } from "./CameraView.vue?vue&type=template&id=f0af6140&scoped=true&"
import script from "./CameraView.vue?vue&type=script&lang=js&"
export * from "./CameraView.vue?vue&type=script&lang=js&"
import style0 from "./CameraView.vue?vue&type=style&index=0&id=f0af6140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0af6140",
  null
  
)

export default component.exports